<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">平台帐户</li>
            </ol>
        </div>
        <div v-if="menus['M6216']" class="content-operator content-border">
            <router-link v-if="menus['M6216']" :to="{ name: 'adminUserDetail' }">
                <el-button class="btn btn-primary" type="success" size="small" icon="el-icon-circle-plus-outline" round @click="addDevice">添加</el-button>
            </router-link>
            <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">刷新</el-button>
        </div>
        <hr />
        <div class="title">
            <span>平台帐户</span>
        </div>
        <div class="content-data" v-if="0 < localUsers.length">
            <el-table highlight-current-row :data="localUsers" border>
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column align="center" label="账户">
                    <template slot-scope="scope">
                        <span>{{scope.row.username}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" fixed="right" label="操作">
                    <template slot-scope="scope">
                        <router-link v-if="menus['M7141']" :to="{ name: 'adminUserPassword', query: { userId: scope.row.userId } }">
                            <el-button type="primary" size="mini">重置密码</el-button>
                        </router-link>
<!--                        <router-link v-if="menus['M4216']" :to="{ name: 'userBindRole', query: { userId: scope.row.userId } }">-->
<!--                            <el-button type="primary" size="mini">修改绑定角色</el-button>-->
<!--                        </router-link>-->
                        <el-button v-if="menus['M9561']" @click="deleteLocalUser(scope.row.id)" type="danger" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="/localUser/pageLocalUser" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            localUsers: [],
            query: {
                type:'SYSTEM'
            },
            menus: {},
        }
    },
    created() {
        var _this = this;
        _this.menus =_this.$common.cache("menus");
    },
    methods: {
        fillData(_response) {
            var _this = this;
            if(_response.items){
                _this.localUsers = _response.items ||[];
            }
        },
        submitQuery(_num) {
            var _this = this;
            _this.localUsers = [];
            _this.$refs.pager.gotoPage(_num);
        },
        deleteLocalUser: function(_localUserId) {
            var _this = this;
            _this.$confirm('是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$common.my_ajax({
                    url: 'localUser/deleteLocalUser',
                    data: {
                        localUserId: _localUserId
                    },
                    success: function(response) {
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.submitQuery();
                            }
                        });
                    }
                });
            }).catch(() => {
                console.log('取消删除');
            });
        },
    }
}
</script>
<style scoped>
td {
    text-align: center;
}
.table tr th{
    text-align: center; 
}
</style>